import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';
import { createPopper } from '@popperjs/core';

import IMask from 'imask';

import search from './search';

import cookie from './cookie';

document.addEventListener('DOMContentLoaded', function () {
    // Маски ввода телефона
    document.querySelectorAll('.js-input-mask[data-mask]').forEach(function (inputMaskEl) {
        const maskOptions = {
            mask: inputMaskEl.getAttribute('data-mask')
        };
        return new IMask(inputMaskEl, maskOptions);
    });

    function clearSearch(containerEl) {
        containerEl.querySelector(".dh-search__results-title").innerHTML = '';
        containerEl.querySelector(".dh-search__results-inner").innerHTML = '';
        containerEl.querySelector(".dh-search__results-empty").classList.add("d-none");
        containerEl.querySelector(".dh-search__results-link").classList.add("d-none");
        containerEl.querySelector('.dh-search__results-loader').classList.remove("active");
        document.body.classList.remove("overflow-hidden");
        containerEl.classList.add("d-none");
    }

    // Поиск
    const searchInputEl = document.querySelector(".js-search-input");
    if (searchInputEl) {
        let searchTimeout = null;
        const containerEl = document.querySelector(".js-search-results");

        searchInputEl.addEventListener("focus", function () {
            const value = searchInputEl.value;
            if (value) {
                search(value, containerEl, searchTimeout);
            }
        });

        searchInputEl.addEventListener("blur", function (e) {
            if (e.relatedTarget && containerEl.contains(e.relatedTarget)) {
                return;
            }
            
            setTimeout(() => {
                clearSearch(containerEl);
            }, 150);
        });

        searchInputEl.addEventListener("input", function () {
            const value = searchInputEl.value;
            if (value) {
                search(value, containerEl, searchTimeout);
            } else {
                if (searchTimeout) {
                    clearTimeout(searchTimeout);
                }
                searchTimeout = setTimeout(function () {
                    clearSearch(containerEl);
                    return () => clearTimeout(searchTimeout);
                }, 500);
            }
        });
    }

    const searchResultsLinkEl = document.querySelector(".dh-search__results-link");
    const searchFormEl = document.getElementById("js-search-form");
    if (searchResultsLinkEl && searchFormEl) {
        searchResultsLinkEl.addEventListener("click", function () {
            searchFormEl.requestSubmit();
        });
    }

    // Меню (top-layer popover + Popper; floating UI вне .swiper)
    const menuCarouselEl = document.querySelector("[data-swiper='menu-carousel']");
    let menuSwiperInstance = null;
    if (menuCarouselEl) {
        menuSwiperInstance = new Swiper(menuCarouselEl, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            updateOnWindowResize: true,
            preloadImages: false,
            lazy: true,
            modules: [Navigation],
            navigation: {
                nextEl: '.dh-menu__swiper .swiper-next',
                prevEl: '.dh-menu__swiper .swiper-prev',
            },
        });
    }

    const menuPopoverEl = document.getElementById('js-menu-subcategory-popover');
    if (menuPopoverEl) {
        const supportsPopover = typeof menuPopoverEl.showPopover === 'function';
        let menuCategoryRefEl = null;
        let menuHideTimeout = null;

        const menuVirtualReference = {
            getBoundingClientRect() {
                return menuCategoryRefEl
                    ? menuCategoryRefEl.getBoundingClientRect()
                    : new DOMRect(0, 0, 0, 0);
            },
        };

        const menuPopperInstance = createPopper(menuVirtualReference, menuPopoverEl, {
            strategy: 'fixed',
            placement: 'bottom-start',
        });

        function cancelMenuSubcategoryHide() {
            if (menuHideTimeout) {
                clearTimeout(menuHideTimeout);
                menuHideTimeout = null;
            }
        }

        function scheduleMenuSubcategoryHide() {
            cancelMenuSubcategoryHide();
            menuHideTimeout = setTimeout(function () {
                hideMenuSubcategory();
            }, 200);
        }

        function updateMenuCategoryAriaExpanded(activeCategoryEl) {
            document.querySelectorAll('.js-menu-category').forEach(function (el) {
                el.setAttribute(
                    'aria-expanded',
                    activeCategoryEl && el === activeCategoryEl ? 'true' : 'false',
                );
            });
        }

        function hideMenuSubcategory() {
            cancelMenuSubcategoryHide();
            menuCategoryRefEl = null;
            updateMenuCategoryAriaExpanded(null);
            menuPopoverEl.classList.remove('is-open');
            if (supportsPopover) {
                try {
                    menuPopoverEl.hidePopover();
                } catch (_e) {
                    // ignore
                }
            }
            menuPopoverEl.replaceChildren();
        }

        function showMenuSubcategory(categoryEl) {
            cancelMenuSubcategoryHide();
            const id = categoryEl.dataset.categoryId;
            const template = document.getElementById('js-menu-subcategory-template-' + id);
            if (!template) {
                return;
            }
            menuPopoverEl.replaceChildren(template.content.cloneNode(true));
            menuCategoryRefEl = categoryEl;
            updateMenuCategoryAriaExpanded(categoryEl);
            menuPopoverEl.classList.add('is-open');
            if (supportsPopover) {
                menuPopoverEl.showPopover();
            }
            requestAnimationFrame(function () {
                menuPopperInstance.update();
            });
        }

        document.querySelectorAll('.js-menu-category').forEach(function (categoryEl) {
            categoryEl.addEventListener('mouseenter', function () {
                showMenuSubcategory(categoryEl);
            });
            categoryEl.addEventListener('mouseleave', function () {
                scheduleMenuSubcategoryHide();
            });
            categoryEl.addEventListener('focus', function () {
                showMenuSubcategory(categoryEl);
            });
            categoryEl.addEventListener('blur', function (e) {
                if (e.relatedTarget && menuPopoverEl.contains(e.relatedTarget)) {
                    return;
                }
                scheduleMenuSubcategoryHide();
            });
        });

        menuPopoverEl.addEventListener('mouseenter', cancelMenuSubcategoryHide);
        menuPopoverEl.addEventListener('mouseleave', scheduleMenuSubcategoryHide);

        menuPopoverEl.addEventListener('focusout', function (e) {
            const next = e.relatedTarget;
            if (
                next &&
                (menuPopoverEl.contains(next) || (next.closest && next.closest('.js-menu-category')))
            ) {
                return;
            }
            scheduleMenuSubcategoryHide();
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && menuPopoverEl.classList.contains('is-open')) {
                hideMenuSubcategory();
            }
        });

        if (menuSwiperInstance) {
            menuSwiperInstance.on('slideChangeTransitionEnd', function () {
                if (menuCategoryRefEl) {
                    menuPopperInstance.update();
                }
            });
        }
    }

    // Карусель статей
    const articlesCarouselEl = document.querySelector("[data-swiper='articles-carousel']");
    if (articlesCarouselEl) {
        new Swiper(articlesCarouselEl, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            updateOnWindowResize: true,
            preloadImages: false,
            lazy: true,
            modules: [Navigation],
            navigation: {
                nextEl: '.dh-articles-carousel .swiper-next',
                prevEl: '.dh-articles-carousel .swiper-prev',
            },
        });
    }

    // Счетчик сравнения
    const setComparisonCounter = (count) => {
        const value = parseInt(count);
        const comparisonCounterEl = document.querySelector(".js-comparison-counter");
        if (!isNaN(value) && comparisonCounterEl) {
            comparisonCounterEl.innerHTML = value > 0 ? (value > 99 ? "99+" : value) : "";
        }
    };

    // Переключатель сравнения
    const comparisonCheckboxEl = document.querySelectorAll('input[type="checkbox"].js-switch-comparison-state');
    comparisonCheckboxEl.forEach(function (checkboxEl) {
        checkboxEl.addEventListener("change", async function () {
            checkboxEl.setAttribute("disabled", "disabled");

            let currentState = checkboxEl.checked;

            const product_id = Number(checkboxEl.dataset.product);
            const category_id = Number(checkboxEl.dataset.category);

            const url = currentState ? "/comparison/ajax/add" : "/comparison/ajax/remove";

            if (!isNaN(product_id) && !isNaN(category_id)) {
                const body = new FormData();
                body.append("category_id", category_id);
                body.append("product_id", product_id);
                try {
                    const response = await fetch(url, {
                        method: "POST",
                        body,
                    });
                    const data = await response.text();
                    setComparisonCounter(data);
                    checkboxEl.checked = currentState;
                } catch (e) {
                    console.error(e);
                }
            }
            checkboxEl.removeAttribute("disabled");
        });
    });

    // Переключатель специальных предложений
    const specialProductsCarouselEl = document.querySelector("[data-swiper='special-products-carousel']");
    let specialProductsCarouselInstance;
    if (specialProductsCarouselEl) {
        specialProductsCarouselInstance = new Swiper(specialProductsCarouselEl, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            updateOnWindowResize: true,
            preloadImages: false,
            lazy: true,
            autoHeight: true,
            modules: [Navigation],
            navigation: {
                nextEl: '.dh-special-products .swiper-next',
                prevEl: '.dh-special-products .swiper-prev',
            },
            breakpoints: {
                768: {
                    slidesOffsetBefore: 260,
                },
                1440: {
                    slidesOffsetBefore: 326,
                }
            }
        });
    }

    const specialProductsLinkEl = document.getElementById("js-special-products-link");
    if (specialProductsLinkEl) {
        specialProductsLinkEl.addEventListener("click", function () {
            const currentState = specialProductsLinkEl.dataset.currentState;
            const newState = currentState === "new" ? "best" : "new";
            specialProductsLinkEl.dataset.currentState = newState;
            const titleEl = specialProductsLinkEl.parentElement.querySelector(".dh-special-products__thumbnail-title");
            const descriptionEl = specialProductsLinkEl.parentElement.querySelector(".dh-special-products__thumbnail-description");
            titleEl.textContent = titleEl.dataset[`state${newState.charAt(0).toUpperCase() + newState.slice(1)}`];
            descriptionEl.textContent = descriptionEl.dataset[`state${newState.charAt(0).toUpperCase() + newState.slice(1)}`];

            const productsContainerEl = specialProductsLinkEl.closest(".dh-special-products__swiper");
            const productsItemsEl = productsContainerEl.querySelectorAll(".dh-special-products__slide");
            productsItemsEl.forEach(function (productItemEl) {
                productItemEl.classList.toggle("d-none", productItemEl.dataset.state === newState);
            });

            if (specialProductsCarouselEl && specialProductsCarouselInstance) {
                specialProductsCarouselInstance.slideTo(0);
            }
        });
    }

    // Мобильное меню
    const mobileMenuBtnEl = document.getElementById("js-mobile-menu-btn");
    const mobileMenuEl = document.getElementById("js-mobile-menu");
    if (mobileMenuBtnEl && mobileMenuEl) {
        mobileMenuBtnEl.addEventListener("click", function () {
            document.documentElement.scrollTo(0, 0, { behavior: "smooth" });
            document.body.classList.toggle("overflow-hidden");
            // document.querySelector(".js-search-results").classList.add("d-none");
            mobileMenuEl.classList.toggle("show");
        });
    }

    // Переключатель мобильного меню
    const mobileMenuToggleEl = document.getElementById("js-mobile-menu-toggle");
    const mobileMenuInnerEl = document.getElementById("js-mobile-menu-inner");
    const mobileMenuCategoriesContainerEl = document.getElementById("js-mobile-menu-categories");

    if (mobileMenuToggleEl && mobileMenuInnerEl) {
        mobileMenuToggleEl.addEventListener("click", function () {
            mobileMenuInnerEl.classList.add("d-none");
            mobileMenuCategoriesContainerEl.classList.remove("d-none");
        });
    }

    const mobileMenuCategoriesEls = document.querySelectorAll(".js-mobile-menu-category");
    if (mobileMenuCategoriesEls) {
        mobileMenuCategoriesEls.forEach(function (categoryEl) {
            categoryEl.addEventListener("click", function () {
                const categoryId = categoryEl.dataset.categoryId;
                const subcategoriesContainerEl = document.querySelector(`.js-mobile-menu-subcategories[data-category-id="${categoryId}"]`);

                if (subcategoriesContainerEl) {
                    mobileMenuCategoriesContainerEl.classList.add("d-none");
                    subcategoriesContainerEl.classList.remove("d-none");
                }
            });
        });
    }

    const mobileMenuSubcategoriesBackEls = document.querySelectorAll(".js-mobile-menu-subcategory-back");
    if (mobileMenuSubcategoriesBackEls) {
        mobileMenuSubcategoriesBackEls.forEach(function (subcategoryBackEl) {
            subcategoryBackEl.addEventListener("click", function () {
                const categoryId = subcategoryBackEl.dataset.categoryId;
                const subcategoriesContainerEl = document.querySelector(`.js-mobile-menu-subcategories[data-category-id="${categoryId}"]`);

                if (subcategoriesContainerEl) {
                    subcategoriesContainerEl.classList.add("d-none");
                    mobileMenuCategoriesContainerEl.classList.remove("d-none");
                }
            });
        });
    }

    const mobileMenuCategoryBackEl = document.getElementById("js-mobile-menu-category-back");
    if (mobileMenuCategoryBackEl) {
        mobileMenuCategoryBackEl.addEventListener("click", function () {
            mobileMenuCategoriesContainerEl.classList.add("d-none");
            mobileMenuInnerEl.classList.remove("d-none");
        });
    }

    const cookieConsentEl = document.getElementById("js-cookie-consent");
    const cookieConsentBtnCloseEl = document.getElementById("js-cookie-consent-btn-close");
    const cookieConsentAccepted = cookie.getCookie("defender-home_cookie-consent");
    if (cookieConsentEl && !cookieConsentAccepted) {
        cookieConsentEl.classList.remove("d-none");
    }

    if (cookieConsentBtnCloseEl && cookieConsentEl) {
        cookieConsentBtnCloseEl.addEventListener("click", function () {
            cookie.setCookie("defender-home_cookie-consent", true, { secure: true, 'max-age': 3600 * 24 * 30 * 365 });
            cookieConsentEl.classList.add("d-none");
        });
    }
}); 
